export const AppSettings = {
  apiHost: process.env.REACT_APP_API_HOST
    ? process.env.REACT_APP_API_HOST
    : 'https://api.aida2.digipartner.se',
  apiUrl: process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : 'https://api.aida2.digipartner.se/api'
};
